import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC38sALAFFegwpc2a-q87VUwXFaXLNED8s",
  authDomain: "digital-trip-concierge.firebaseapp.com",
  projectId: "digital-trip-concierge",
  storageBucket: "digital-trip-concierge.firebasestorage.app",
  messagingSenderId: "1078940647088",
  appId: "1:1078940647088:web:3d9d5e627a7bf6b6614575"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;